import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-style-four',
  templateUrl: './courses-style-four.component.html',
  styleUrls: ['./courses-style-four.component.scss']
})
export class CoursesStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
